import React from 'react';
import Row from "../../UI/Row";
import {formatDate} from "../../../utilities/formatter";
import {useDashboard} from "../../../utilities/context/dashboard/dashboard-context";

const Addon = () => {

}

const SubscriptionDisplay = ({onClick}) => {

    const {subscription} = useDashboard();

    const handleClick = () => {
        onClick && onClick();
    }

    return (
        <div className="flex flex-col md:flex-row justify-between">
            {subscription &&
            <Row className="gap-8">
                <div>
                    <div className="text-xs">Il tuo abbonamento</div>
                    <div className="text-xl font-bold text-ea_yellow">{subscription.subscription.name}</div>
                    <Row className="items-center gap-2">
                        <div className="text-xs">Giorni mancanti:</div>
                        <div className="font-medium">{parseFloat(subscription.missing_days).toFixed(0)}</div>
                    </Row>
                    <Row className="text-sm">
                        <div className="w-20">Inizio: </div><div className="font-medium text-sm">{formatDate(subscription.start_date)}</div>
                    </Row>
                    <Row className="text-sm">
                        <div className="w-20">Scadenza: </div><div className="font-medium text-sm">{formatDate(subscription.deadline)}</div>
                    </Row>
                </div>
            </Row>
            }
            {subscription?.subscription?.type === "initial" &&
            <div className="">
                {subscription?.users_addons &&
                <div className="text-sm mt-4 md:mt-0">
                    <div className="text-xs">Pacchetti Aggiuntivi</div>
                    <div className="flex flex-row items-center flex-wrap gap-1 pt-1">
                        {subscription?.users_addons.length > 0 ?
                            subscription.users_addons.map((addon, i) =>
                                <span className="font-medium uppercase text-sm leading-none border rounded p-1" key={i}>{addon.name}</span>)
                            :
                            <div className=" italic text-gray-300">Nessun pacchetto aggiuntivo</div>
                        }
                    </div>

                </div>
                }
                {onClick &&
                <div
                    className="text-center mt-2 font-bold text-ea_yellow cursor-pointer hover:underline hidden md:block text-xs"
                    onClick={handleClick}>Acquista un pacchetto aggiuntivo
                </div>
                }

            </div>
            }
        </div>
    );
};

export default SubscriptionDisplay;